import { parseToRgb, rgba } from 'polished'

/**
 * Used for applying alpha value to color returned by tone function
 */
export const hexToRgba = (alpha: number, hexColor: string) => {
  const rgbColor = parseToRgb(hexColor)
  return rgba({ ...rgbColor, alpha })
}
